import { z } from 'zod';

import { Api, SuccessResponse } from '@/lib/api';

import { IAuth, IPermission, IRole, IRoleCreate, IRoleUpdate, IUser, IUserCreate, IUserUpdate } from './models';
import { loginSchema } from './schemas';

export const UserApi = {
  login: (data: z.infer<typeof loginSchema>) =>
    Api.post<SuccessResponse<IAuth>>({
      urlName: 'auth:login',
      data,
    }),

  //USERS API
  listUsers: () =>
    Api.get<SuccessResponse<IUser[]>>({
      urlName: 'users:list',
    }),

  listUsersWithAdmin: () =>
    Api.get<SuccessResponse<IUser[]>>({
      urlName: 'users:list-admin',
    }),

  getUser: (userId: number | string) =>
    Api.get<SuccessResponse<IUser>>({
      urlName: 'users:id',
      ids: [userId],
    }),

    getCurrentUser: () =>
    Api.get<SuccessResponse<IUser>>({
      urlName: 'users:me',
    }),

  updateUser: (userId: number, data: IUserUpdate) =>
    Api.patch<SuccessResponse<IUser>>({
      urlName: 'users:id',
      ids: [userId],
      data,
    }),
  createUser: (data: IUserCreate) => {
    return Api.post<SuccessResponse<IUser>>({
      urlName: 'users:list',
      data,
    });
  },

  deleteUser: (userId: number) =>
    Api.delete<SuccessResponse<IUser>>({
      urlName: 'users:id',
      ids: [userId],
    }),

  //ROLES API
  listRoles: () => Api.get<SuccessResponse<IRole[]>>({ urlName: 'roles:list' }),

  createRole: (data: IRoleCreate) =>
    Api.post<SuccessResponse<IRole>>({
      urlName: 'roles:list',
      data,
    }),

  updateRole: (data: IRoleUpdate) =>
    Api.put<SuccessResponse<IRole>>({
      urlName: 'roles:list',     
      data,
    }),

  deleteRole: (roleId: number) =>
    Api.delete<SuccessResponse<IRole>>({
      urlName: 'roles:id',
      ids: [roleId],
    }),

  //PERMISSIONS API
  listPermissions: () =>
    Api.get<SuccessResponse<IPermission[]>>({ urlName: 'permissions:list' }),
  
} as const;
